/**
 * Haptic feedback utility for mobile devices.
 * Uses the Vibration API (works on Android, some iOS via Capacitor).
 * Falls back silently on unsupported devices.
 */

const canVibrate = () => typeof navigator !== 'undefined' && 'vibrate' in navigator;

export const haptics = {
  /** Light tap — button presses, toggles */
  light: () => canVibrate() && navigator.vibrate(10),

  /** Medium tap — successful actions, confirmations */
  medium: () => canVibrate() && navigator.vibrate(25),

  /** Heavy tap — errors, warnings, destructive actions */
  heavy: () => canVibrate() && navigator.vibrate(50),

  /** Success pattern — task completed, goal reached */
  success: () => canVibrate() && navigator.vibrate([15, 50, 15]),

  /** Error pattern — failed action */
  error: () => canVibrate() && navigator.vibrate([50, 30, 50]),

  /** Selection change — switching tabs, carousel */
  selection: () => canVibrate() && navigator.vibrate(5),
};
